<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsCommunicationDigitale'
});
</script>
<template>
  <ka-container
    code="prog-07-communication-digitale"
    :data="page.$info.prog07CommunicationDigitale">
    <!-- Page formation -->
    <ka-container code="page-formation">
      <PFormationEntete
        instance-class="p-formation-entete--p55"
        h-1="Formation en communication digitale"
        texte="La formation est réalisée par un<strong> expert en communication digitale</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <h2 v-html="t('prog07CommunicationDigitale.pageFormation.containerExperts.titre.value', `Nos experts en communication digitale`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog07CommunicationDigitale.pageFormation.containerExperts.texte.value', `La communication digitale est un large sujet dont vous maîtrisez peut-être déjà certains volets. Pour une formation 100% utile, Matchers se charge de faire matcher le profil qui pourra vous permettre d’atteindre vos objectifs, qu’ils soient stratégiques, opérationnels ou les deux sans perdre de temps sur de grands principes théoriques ! Toujours en poste, ils sont conscients du quotidien et des contraintes en entreprise. Axés sur l’efficacité et tous issus de secteurs d’activité différents, le profil idéal pour vous accompagner se trouve assurément au sein de notre communauté.`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p55"
            :options="{
              href: `https://www.matchers.fr/expert/306`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Experte en stratégie digitale"
            first-name="Olivia"
            enttreprise="&#64;Yves Rocher"
            image="https://ucarecdn.com/e1f1559f-5d30-45f0-a062-cf833d425f08/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p55"
            :options="{
              href: `https://www.matchers.fr/expert/266`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :tags="page.$constants.element1Tags"
            poste="Head of video development"
            first-name="Julien"
            enttreprise="&#64;Splashr"
            image="https://ucarecdn.com/bc078d6c-2030-46dd-83fa-ca8a87744207/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p55"
            :options="{
              href: `https://www.matchers.fr/expert/457`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :tags="page.$constants.element2Tags"
            poste="Responsable communication"
            first-name="Margaux"
            enttreprise="&#64;Michel & Augustin"
            image="https://ucarecdn.com/88b35312-be48-4467-970c-3c0179fb1bee/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p55"
            :options="{
              href: `https://www.matchers.fr/expert/274`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element3Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element3Tags"
            poste="Graphiste et marketeuse"
            first-name="Joanna"
            enttreprise="&#64;Deleo"
            image="https://ucarecdn.com/c2012797-8e23-4c8a-9622-e798aaafe483/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog07CommunicationDigitale.pageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog07CommunicationDigitale.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p55"
                  titre="I.   Définir son positionnement et identifier les acteurs inspirationnels du marché"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-1">
                <DropDownFormation
                  instance-class="element-4--p55"
                  titre="II.   Connaître les moyens pour donner de la visibilité à sa marque et ses produits"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-5--p55"
                  titre="III.   Construire une stratégie de communication pensée et organisée"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-6--p55"
                  titre="IV.   Analyser le retour de ses actions"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p55" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p55"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p55" />
      <PFormationMatching
        instance-class="p-formation-matching--p55"
        description-company="<strong>Domaine d'Arton</strong> | Domaine producteur d'Armagnac et de vin.<br> <br> <br><strong>Besoin : </strong>Développer sa notoriété en ligne."
        expert-text="<strong>Anne-Claire </strong>| Responsable de la Communication | &#64;Michel et Augustin.<br> <br> <br><strong>Expertise : </strong>Plus de 10 ans d'expérience en communication et marketing (communication interne, digitale, relations presse, marketing de contenu...)."
        budget-available="4 800€"
        training-hours="30h"
        photo-expert="https://ucarecdn.com/868ce7a9-ca1b-47f0-ba8f-9eaebd6f8f4b/"
        image="https://ucarecdn.com/5976abc2-1b5c-457a-8809-a45d03fe7f97/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p55" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p55" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsCommunicationDigitale } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p55')
const appData = appDataStore()
const page = formationsCommunicationDigitale()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
